import { createSelector } from 'reselect'

import { selectFinSobSidePanelState } from './selectFinSobSidePanelState'

export const selectCategoryWithLoadingCompletenessStatus = createSelector(
  [selectFinSobSidePanelState],
  ({ categoryWithLoadingCompletenessStatus }) => categoryWithLoadingCompletenessStatus
)
